import * as utils from '@/lib/utils';


const state = () => ({
    privileges: {} as Promise<UserPrivileges>,
    firms: [] as Firm[],
    paymentTypes: [] as string[],
    carServices: [] as CarService[],
    selectedFirm: undefined,
    dates: utils.currentWeek(),
});

const mutations = {
    setUserPrivileges(state: any, payload: UserPrivileges) {
        state.privileges = payload;
    },
    setFirms(state: any, payload: Firm[]) {
        state.firms = payload;
    },
    setSelectedFirm(state: any, payload: string) {
        state.selectedFirm = payload;
    },
    setDates(state: any, payload: string[]) {
        state.dates = payload;
    },
    setPaymentTypes(state: any, payload: string[]) {
        state.paymentTypes = payload;
    },
    setCarServices(state: any, payload: string[]) {
        state.carServices = payload;
    },
};

const getters = {};

const actions = {

};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
